import { Button, Img, MobileInput, Text } from "components";
import { useTranslation } from "react-i18next";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as API from "../../../../utils/helper/Enum";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import * as CUSTOM from "../../../../utils/helper/custom";
import { useEffect, useRef, useState } from "react";
import { eachDayOfInterval } from "date-fns";
import {
  getGiftOrderData,
  updateGiftOrderData,
} from "../../../../redux/reducers/giftOrderData";

const StepsYourDetail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const orderData = useSelector(getGiftOrderData);
  const [timer, setTimer] = useState(0);

  // Pre-fill mobile_no from Redux if user comes back to this step
  const savedMobile = orderData?.mobile_no || "";

  // If mobile already verified before (savedMobile exists), show read-only view directly
  const [isVerified, setIsVerified] = useState(!!savedMobile);

  const [inputData, setInputData] = useState({
    enableVerify: savedMobile ? !CUSTOM.isValidField(savedMobile, "mobile") : true,
    sentOtp: false,
    otp: "",
    enableContinue: true,
    mobile_no: savedMobile,
  });

  // Refs for OTP digit inputs
  const otpRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);

  /**
   * send otp on mobile no
   */
  const sendOtp = async () => {
    // console.log(orderData?.orderDetails?.giftDetails?.mobile_no, inputData?.mobile_no, "mobile_no")
    // if (orderData?.orderDetails?.giftDetails?.mobile_no.split("-")[1] == inputData?.mobile_no && inputData?.mobile_no) {
    //   saveUserData();
    //   return;
    // }
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${API.OTP.SEND_OTP}`,
        "post",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        setTimer(process.env.REACT_APP_OTP_TIMER);
        setInputData({ ...inputData, sentOtp: true, otp: "" });
        setOtpDigits(["", "", "", ""]);
        setTimeout(() => otpRefs[0]?.current?.focus(), 100);
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * verify Otp
   */
  const verifyOtp = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${API.OTP.VERIFY_OTP}`,
        "post",
        inputData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        saveUserData();
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: eachDayOfInterval?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * Check mobile number is valid or not
   */
  const checkMobileNumber = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${API.GIFTORDER.CHECK_MOBILE_NUMBER}`,
        "post",
        {
          order_id: orderData?.orderDetails?.id,
          mobile_number: inputData?.mobile_no,
        },
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        // saveUserData();
        sendOtp();
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: eachDayOfInterval?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * save user data
   */
  const saveUserData = () => {
    setIsVerified(true);
    setInputData({
      enableVerify: false,
      sentOtp: false,
      otp: "",
      enableContinue: true,
      mobile_no: inputData?.mobile_no,
    });
    dispatch(
      updateGiftOrderData({
        ...orderData,
        mobile_no: inputData?.mobile_no,
        pageStep: 2,
      })
    );
  };

  /**
   * Handle OTP digit input
   */
  const handleOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const newDigits = [...otpDigits];
    newDigits[index] = digit;
    setOtpDigits(newDigits);

    const fullOtp = newDigits.join("");
    setInputData({ ...inputData, otp: fullOtp });

    // Auto-focus next
    if (digit && index < 3) {
      otpRefs[index + 1]?.current?.focus();
    }
  };

  /**
   * Handle OTP backspace
   */
  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      otpRefs[index - 1]?.current?.focus();
    }
  };

  /**
   * check and update button state when enter the mobile number verify button should be enable
   */
  useEffect(() => {
    if (inputData?.mobile_no) {
      let statusVerify = true;
      if (CUSTOM.isValidField(inputData?.mobile_no, "mobile")) {
        statusVerify = false;
      }
      setInputData({ ...inputData, enableVerify: statusVerify });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData?.mobile_no]);

  /**
   * check and update button state when enter the otp continue button should be enable
   */
  useEffect(() => {
    if (inputData?.otp) {
      let enableContinue = true;
      if (inputData?.otp.length == 4) {
        enableContinue = false;
      }
      setInputData({ ...inputData, enableContinue: enableContinue });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData?.otp]);

  /**
   * timer set for otp
   */
  useEffect(() => {
    let interval;
    const countdown = () => {
      if (timer > 0) {
        setTimer((prevTimer) => prevTimer - 1);
      }
    };
    interval = setInterval(countdown, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  // ── Read-only view: number already verified, user came back via stepper ──
  if (isVerified) {
    return (
      <div className="flex flex-row items-center justify-between w-full">
        <div className="flex flex-col gap-1">
          <Text className="text-base text-black-900 font-['Unbounded']">
            {t("yourDetails")}
          </Text>
          <div className="flex gap-2 flex-row items-center">
            <Text className="text-gray-600 text-sm font-['Inter']">
              +966 {orderData?.mobile_no}
            </Text>
            <svg viewBox="0 0 24 24" className="h-4 w-4 flex-shrink-0" fill="none" stroke="#2dd4bf" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <button
          className="border border-gray-300 rounded-lg px-4 py-1.5 text-sm font-['Unbounded'] text-black-900 hover:bg-gray-50 transition-colors"
          onClick={() => {
            // User wants to change number: clear verification and show form
            setIsVerified(false);
            setInputData({
              enableVerify: false,
              sentOtp: false,
              otp: "",
              enableContinue: true,
              mobile_no: savedMobile,
            });
            setOtpDigits(["", "", "", ""]);
          }}
        >
          {t("change")}
        </button>
      </div>
    );
  }

  return (
    <div className="relative flex flex-col w-full">
      {/* Section Header */}
      <div className="mb-5">
        <Text className="text-lg text-black-900 font-['Unbounded']">
          {t("yourDetails")}
        </Text>
        <Text className="text-gray-500 text-sm font-['Unbounded'] mt-0.5">
          {inputData?.sentOtp
            ? `OTP sent to +966 ${inputData?.mobile_no}`
            : t("verifyMobileNumberToSubmittingTheDetails")}
        </Text>
      </div>

      {!inputData?.sentOtp ? (
        /* Mobile Number Input */
        <div className="flex flex-col gap-4 w-full">
          <div className="w-full max-w-[420px]">
            <MobileInput
              required
              label={t("mobile")}
              className="w-full"
              onChange={(e) => {
                setInputData({
                  ...inputData,
                  mobile_no: CUSTOM.strFormat(e.target.value, "max:9|number"),
                });
              }}
              value={inputData?.mobile_no}
            />
          </div>

          <div className="w-full">
            <button
              className={`w-full py-3.5 rounded-full text-white-A700 text-base font-['Unbounded'] transition-all duration-200
                ${inputData?.enableVerify
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-pink-800 hover:bg-pink-900 shadow-md hover:shadow-lg"
                }`}
              disabled={inputData?.enableVerify}
              onClick={checkMobileNumber}
            >
              {t("verify")}
            </button>
          </div>
        </div>
      ) : (
        /* OTP Verification UI */
        <div className="flex flex-col gap-5">
          {/* OTP sent info banner */}
          <div className="bg-green-50 border border-green-200 rounded-xl px-4 py-3">
            <Text className="text-green-700 text-sm font-['Inter']">
              OTP sent to +966 {inputData?.mobile_no}
            </Text>
          </div>

          {/* OTP digit boxes */}
          <div className="flex flex-col gap-2">
            <Text className="text-sm text-black-900 font-['Inter']">
              {t("verificationCode")}
            </Text>
            <div className="flex flex-row gap-3 items-center">
              {otpDigits.map((digit, index) => (
                <input
                  key={index}
                  ref={otpRefs[index]}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleOtpKeyDown(index, e)}
                  className={`h-14 w-14 sm:h-12 sm:w-12 text-center text-xl font-nunitobold border-2 rounded-xl outline-none transition-all
                    ${digit
                      ? "border-pink-800 bg-pink-50 text-pink-800"
                      : "border-gray-200 bg-white-A700 text-black-900"
                    } focus:border-pink-800 focus:shadow-[0_0_0_3px_rgba(157,23,77,0.1)]`}
                />
              ))}
            </div>
          </div>

          {/* Resend OTP */}
          <div className="flex flex-row items-center gap-2">
            <Text className="text-gray-500 text-sm font-['Inter']">
              Didn't receive Code?
            </Text>
            <button
              className={`text-sm font-['Inter'] transition-colors ${
                timer === 0
                  ? "text-pink-800 hover:text-pink-900 cursor-pointer"
                  : "text-gray-400 cursor-not-allowed"
              }`}
              onClick={() => { if (timer === 0) sendOtp(); }}
            >
              Resend OTP {timer !== 0 ? `(${timer}s)` : ""}
            </button>
          </div>

          {/* Action buttons */}
          <div className="flex flex-row gap-3 w-full max-w-[420px] mt-1">
            <button
              className="flex-1 py-3.5 rounded-xl border border-gray-300 text-black-900 text-sm font-['Unbounded'] hover:bg-gray-50 transition-colors"
              onClick={() => {
                setInputData({ ...inputData, sentOtp: false, otp: "" });
                setOtpDigits(["", "", "", ""]);
              }}
            >
              Change Number
            </button>
            <button
              className={`flex-1 py-3.5 rounded-xl text-white-A700 text-sm font-['Unbounded'] transition-all duration-200
                ${inputData?.enableContinue
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-pink-800 hover:bg-pink-900 shadow-md"
                }`}
              disabled={inputData?.enableContinue}
              onClick={verifyOtp}
            >
              {t("verify")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepsYourDetail;